// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"24a95fce","544":"5ce44b99"}[chunkId] + ".chunk.js";
};